import { render, staticRenderFns } from "./PeakEvents.vue?vue&type=template&id=6bdd46ae&"
import script from "./PeakEvents.vue?vue&type=script&lang=js&"
export * from "./PeakEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bdd46ae')) {
      api.createRecord('6bdd46ae', component.options)
    } else {
      api.reload('6bdd46ae', component.options)
    }
    module.hot.accept("./PeakEvents.vue?vue&type=template&id=6bdd46ae&", function () {
      api.rerender('6bdd46ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/devices/devicedetail/peakevents/PeakEvents.vue"
export default component.exports